<template>
  <content-container :showCastle="true">
    <div class="home-container">
      <div>
        <div class="pre-header">Select Your</div>
        <div class="main-header">Hogwarts</div>
        <div class="main-header">House</div>
      </div>
      <separator big="true" />
      <div v-if="tokenValid" class="button-container">
        <router-link to="/form" class="btn">Continue</router-link>
      </div>
      <div v-else>
        <div class="page-expired">{{expiredMessage}}</div>
        <div>Please re-scan the QR code</div>
      </div>
    </div>
  </content-container>
</template>

<script>
import separator from "../../components/seperator.vue";
import ContentContainer from "../../components/content-container.vue";
import Axios from "axios";

export default {
  components: { separator, "content-container": ContentContainer },
  computed: {
    tokenValid: function () {
      console.log(this.$root.$data.state.tokenValid);
      return this.$root.$data.state.tokenValid;
    },
    expiredMessage: function () {
      return this.$root.$data.state.error ? "There was an error" : "Page Has Expired";
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/global.scss";

.home-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;

  > div {
    width: 95%;
    &.button-container {
      @media (min-width: $tablet-min-width) {
        width: 75%;
      }
    }
    &:last-child {
      height: 3.25em;
    }
  }

  .pre-header {
    font-size: 1.25em;
  }

  .main-header {
    text-transform: uppercase;
    font-size: 2.25em;
    line-height: 1.5;
    letter-spacing: 1px;

    font-family: Imperator, "Courier New", Courier, monospace;
  }

  .page-expired {
    text-transform: uppercase;
    font-size: 1.25em;
    margin-bottom: 0.5em;
  }
}
</style>
